export const JUMIO_SET_UPLOAD_REQUIREMENT = 'JUMIO:UPLOAD_REQUIREMENT:SET';
export const JUMIO_SET_HAVE_COPY_ID_FAX = 'JUMIO:HAVE_COPY_ID_FAX:SET';

export const setUploadRequirement = (uploadRequirement) => ({
    type: JUMIO_SET_UPLOAD_REQUIREMENT,
    payload: uploadRequirement
});

export const setHaveCopyIDFax = (haveCopyIDFax) => ({
    type: JUMIO_SET_HAVE_COPY_ID_FAX,
    payload: haveCopyIDFax
});
